import { Component, HostBinding, HostListener } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { TimerService } from '@frontend/sports/common/core/utils/timer';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';

@Component({
    selector: 'ms-extended-offer',
    templateUrl: './extended-offer.component.html',
    imports: [IconCustomComponent],
})
export class ExtendedOfferComponent {
    linkToggled: boolean;
    @HostBinding('class') className = 'extended-offer';

    constructor(
        public sitecore: Sitecore,
        private timer: TimerService,
    ) {}

    @HostListener('click', ['$event'])
    click(event: Event): void {
        event.stopPropagation();

        if (this.linkToggled) {
            return;
        }

        this.linkToggled = true;
        this.timer.setTimeout(() => (this.linkToggled = false), 3000);
    }
}
